module.exports = __webpack_public_path__ + "img/avatar.3e099662.png";